import { Component, EventEmitter, Output } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { AgRendererComponent } from "ag-grid-angular";
import { NotificationsService } from '../account/notification-settings-new/services/notifications.service';
import { UserDetails, canOpenIntegrationDetails, IntegrationRef } from '../app.model';
import { AppService } from '../app.service';
import { ChangeDetectorRef } from '@angular/core';
//import { setTimeout } from 'timers';

//import { EventEmitter } from 'events';
import { get as _get, includes as _includes } from 'lodash-es';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-action-render',
  templateUrl: './action-render.component.html',
  styleUrls: ['./action-render.component.scss']
})
export class ActionRenderComponent implements AgRendererComponent {
  constructor(private notificationsService: NotificationsService, private appService: AppService, private cdRef: ChangeDetectorRef) { }
  //@Output() toggleRequest = new EventEmitter<boolean>();
  public params: ICellRendererParams;
  userId;
  isOrgAdmin;
  baseWord;
  isDestination: boolean;
  gridLength: number;
  rowIndex: number;
  innerClicked: boolean;
  isDestinationSet: boolean;
  integrationDetailsDisabled = false;
  isCDKSource: boolean;
  isStudioSourcesList: boolean = false;
  templateId: any;
  userDetails: UserDetails = new UserDetails();
  @Output() refreshRows = new EventEmitter<boolean>();
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isDestinationSet = this.params.data['destinationName'] != null;
    this.userId = this.params['userId'];
    this.isOrgAdmin = this.params['isOrgAdmin'];
    this.baseWord = this.params['baseWord'];
    this.isDestination = this.params['isDestination'];
    this.isStudioSourcesList = this.params['isStudioSourcesList'];
    this.gridLength = this.params['gridLength'];
    this.rowIndex = this.params.node.rowIndex ?? 0;
    this.innerClicked = false;
    this.isCDKSource = _get(this.params, 'data.cdkSource');
    this.templateId = _get(this.params, 'data.templateId');
    this.integrationDetailsDisabled = !canOpenIntegrationDetails(
      this.params?.data?.status,
      this.isDestinationSet
    );
    // this.appService.getUser().then((user) => {
    //   this.userDetails = user;
    // })
  }

  public invokeParentMethod() {
    this.params?.context?.componentParent?.methodFromParent(`Row: ${this.params?.node?.rowIndex}, Col: ${this.params?.colDef?.headerName}`)
  }

  refresh(): boolean {
    return false;
  }

  toggleDropDown(sourceId, status) {
    this.params.context.componentParent.toggleDropDown(sourceId, status)

    setTimeout(() => {
      this.innerClicked = false;
    }, 500)

  }

  toggleDropDownWarehouse(warehouseId) {
    this.params.context.componentParent.toggleDropDownWarehouse(warehouseId)
  }

  onchangeRenewToken(sourceId, type, dataSourceId, sourceMetaData) {
    if(sourceMetaData.isLegacy === false || sourceMetaData.isLegacy === null || sourceMetaData.isLegacy === undefined) {
      this.params.context.componentParent.onChangeRenewTokenSourceService(sourceMetaData);
    } else {
      if (this.isCDKSource) {
        const userId = _get(this.params, 'data.userId');
        const sourceId = _get(this.params, 'data.sourceId');
        const sourceType = _get(this.params, 'data.type');
        this.params.context.componentParent.onchangeRenewTokenCDK(userId, sourceType, sourceId, sourceMetaData)
      } else {
        this.params.context.componentParent.onchangeRenewToken(sourceId, type, dataSourceId, sourceMetaData);
      }
    }
  }

  onChangeSourceStatus(sourceId, actionType, flag, sourceType, dataSourceId, data?: any) {
    this.params.context.componentParent.onChangeSourceStatus(sourceId, actionType, flag, sourceType, dataSourceId, data);
  }

  markAsTemplate(data) {
    //this.params.data.template = !this.params.data.template;
    this.params.context.componentParent.markAsTemplate(data);
  }

  onChangeWarehouseStatus(flag) {

    this.params.context.componentParent.onChangeWarehouseStatus(this.params.data, flag);

  }

  routeToConfigurations(source) {

    this.params.context.componentParent.routeToConfigurations(source);


  }

  routeToDetails() {
    if (this.isDestinationSet) {
      const integration: IntegrationRef = {
        integrationName: this.params.data.integrationName,
        sourceId: this.params.data.sourceId,
        status: this.params.data.status,
        destinationName: this.params.data.destinationName
      };
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }

  routeToEditFlow() {
    let integration = {
      dataSourceType: _get(this.params, 'data.type'),
      sourceId: _get(this.params, 'data.sourceId'),
      dataSourceId: _get(this.params, 'data.datasourceId'),
      integrationName: _get(this.params, 'data.integrationName'),
      templateId: _get(this.params, 'data.templateId')
    }
    if(this.isCDKSource && integration.templateId && integration.templateId !== 0){
      this.params.context.componentParent.routeToCDKTemplateEditFlow(integration)
    }
    else if (this.isCDKSource && !_includes(environment.CDK_ENABLED_SOURCES, integration.dataSourceType)) {
      this.params.context.componentParent.routeToCDKEditFlow(integration)
    } else {
      this.params.context.componentParent.routeToNonCDKEditFlow(integration)
    }

  }

  routeToCloneFlow() {
    let integration = {
      dataSourceType: _get(this.params, 'data.type'),
      sourceId: _get(this.params, 'data.sourceId'),
      dataSourceId: _get(this.params, 'data.datasourceId'),
      integrationName: _get(this.params, 'data.integrationName')
    }

    if (this.isCDKSource && !_includes(environment.CDK_ENABLED_SOURCES, integration.dataSourceType)) {
      this.params.context.componentParent.routeToCDKCloneFlow(integration)
    } else {
      this.params.context.componentParent.routeToNonCDKCloneFlow(integration)
    }
  }

  routeToStudioDetails() {
    let sourceInfo = {
      "dataSourceName": this.params.data.dataSourceName,
      "dataSourceId": this.params.data.dataSourceId,
      "dataSourceCategory": this.params.data.category,
      "dataSourceType": this.params.data.dataSourceType,
    }
    this.params.context.componentParent.routeToStudioFlow(sourceInfo)
  }

  startSource(data) {
    this.params.context.componentParent.startSource(data)
    setTimeout(()=>{
      this.innerClicked = false
    }, 500)
  }

}
